var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0C6.55228 0 7 0.447715 7 1V2H15V1C15 0.447715 15.4477 0 16 0C16.5523 0 17 0.447715 17 1V2H18C20.2091 2 22 3.79086 22 6V19C22 21.2091 20.2091 23 18 23H4C1.79086 23 0 21.2091 0 19V6C0 3.79086 1.79086 2 4 2H5V1C5 0.447715 5.44772 0 6 0ZM4 4C2.89543 4 2 4.89543 2 6V7H20V6C20 4.89543 19.1046 4 18 4H4ZM20 9H2V19C2 20.1046 2.89543 21 4 21H18C19.1046 21 20 20.1046 20 19V9ZM5.5 13C5.5 12.4477 5.94772 12 6.5 12H8.5C9.05229 12 9.5 12.4477 9.5 13C9.5 13.5523 9.05229 14 8.5 14H6.5C5.94772 14 5.5 13.5523 5.5 13ZM12.5 13C12.5 12.4477 12.9477 12 13.5 12H15.5C16.0523 12 16.5 12.4477 16.5 13C16.5 13.5523 16.0523 14 15.5 14H13.5C12.9477 14 12.5 13.5523 12.5 13ZM5.5 17C5.5 16.4477 5.94772 16 6.5 16H8.5C9.05229 16 9.5 16.4477 9.5 17C9.5 17.5523 9.05229 18 8.5 18H6.5C5.94772 18 5.5 17.5523 5.5 17ZM12.5 17C12.5 16.4477 12.9477 16 13.5 16H15.5C16.0523 16 16.5 16.4477 16.5 17C16.5 17.5523 16.0523 18 15.5 18H13.5C12.9477 18 12.5 17.5523 12.5 17Z",
    fill: "#A0AEBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2d832674ed0446f860cf92b3ba8d202d.svg";
export { ForwardRef as ReactComponent };